import dayjs from "dayjs";

import { DAYS_OF_WEEK } from "@/common/constants/misc";
import { LABELS } from "@/common/constants/labels";

export const NOTIFICATION_ID_PROPERTY = "searchNotificationId";

export const NOTIFICATION_FREQUENCY_IMMEDIATELY = "IMMEDIATELY";
export const NOTIFICATION_FREQUENCY_HOURLY = "HOURLY";
export const NOTIFICATION_FREQUENCY_DAILY = "DAILY";
export const NOTIFICATION_FREQUENCY_WEEKLY = "WEEKLY";
export const NOTIFICATION_FREQUENCY_MONTHLY = "MONTHLY";

export const NOTIFICATION_FREQUENCY_OPTIONS = [
  {
    display: "Immediately",
    adverb: NOTIFICATION_FREQUENCY_IMMEDIATELY,
  },
  {
    display: "Hourly",
    adverb: NOTIFICATION_FREQUENCY_HOURLY,
  },
  {
    display: "Daily",
    adverb: NOTIFICATION_FREQUENCY_DAILY,
  },
  {
    display: "Weekly",
    adverb: NOTIFICATION_FREQUENCY_WEEKLY,
  },
  {
    display: "Monthly",
    adverb: NOTIFICATION_FREQUENCY_MONTHLY,
  },
];

export const NOTIFICATION_EXPIRATION_ID_2_WEEKS = 1;
export const NOTIFICATION_EXPIRATION_ID_1_MONTH = 2;
export const NOTIFICATION_EXPIRATION_ID_3_MONTHS = 3;
export const NOTIFICATION_EXPIRATION_ID_6_MONTHS = 4;
export const NOTIFICATION_EXPIRATION_ID_NEVER = 5;

export const NOTIFICATION_EXPIRATION_OPTIONS = [
  {
    id: NOTIFICATION_EXPIRATION_ID_2_WEEKS,
    name: "2 weeks",
    value: 2,
    type: "week",
  },
  {
    id: NOTIFICATION_EXPIRATION_ID_1_MONTH,
    name: "1 month",
    value: 1,
    type: "month",
  },
  {
    id: NOTIFICATION_EXPIRATION_ID_3_MONTHS,
    name: "3 months",
    value: 3,
    type: "month",
  },
  {
    id: NOTIFICATION_EXPIRATION_ID_6_MONTHS,
    name: "6 months",
    value: 6,
    type: "month",
  },
  {
    id: NOTIFICATION_EXPIRATION_ID_NEVER,
    name: "Never",
    value: "never",
    type: null,
  },
];

export const NOTIFICATION_COUNTRIES_LAYER_ID = "layer-country";
export const NOTIFICATION_COUNTRIES_LAYER_FIELD_ID = "_id";
export const NOTIFICATION_CITIES_LAYER_ID = "layer-city";
export const NOTIFICATION_CITIES_LAYER_FIELD_ID = "_id";

export const NOTIFICATION_TRIPWIRE_TYPE_RISK_RATING = "risk-rating";
export const NOTIFICATION_TRIPWIRE_TYPE_EVACUATION = "evacuation";
export const NOTIFICATION_TRIPWIRE_TYPE_HOTSPOT = "hotspot";
export const NOTIFICATION_TRIPWIRE_TYPE_PULSE = "pulse";
export const NOTIFICATION_TRIPWIRE_TYPE_PLANNED_EVENT = "planned-event";
export const NOTIFICATION_TRIPWIRE_TYPE_BREAKING_EVENT = "breaking-event";

export const NOTIFICATION_TRIPWIRE_TYPES = [
  {
    text: "Risk Rating Changes Tripwire",
    value: NOTIFICATION_TRIPWIRE_TYPE_RISK_RATING,
  },
  {
    text: "Evacuation Changes Tripwire",
    value: NOTIFICATION_TRIPWIRE_TYPE_EVACUATION,
  },
  { text: "Hotspots Tripwire", value: NOTIFICATION_TRIPWIRE_TYPE_HOTSPOT },
  {
    text: "Pulse Score Changes Tripwire",
    value: NOTIFICATION_TRIPWIRE_TYPE_PULSE,
  },
  {
    text: "Breaking Events Tripwire",
    value: NOTIFICATION_TRIPWIRE_TYPE_BREAKING_EVENT,
  },
  {
    text: "Future Events Tripwire",
    value: NOTIFICATION_TRIPWIRE_TYPE_PLANNED_EVENT,
  },
];

export const NOTIFICATION_BRIEFING_TYPE_COUNTRY_ANALYSIS = "analysis-briefing";
export const NOTIFICATION_BRIEFING_TYPE_CALENDAR_EVENTS = "calendar-event";
export const NOTIFICATION_BRIEFING_TYPE_REGIONAL_OUTLOOK = "regional-outlook";
export const NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY = "cyber-weekly";
export const NOTIFICATION_BRIEFING_TYPE_CYBER_MONTHLY = "cyber-monthly";

export const NOTIFICATION_BRIEFING_TYPES = [
  {
    text: "Country Analysis Updates",
    value: NOTIFICATION_BRIEFING_TYPE_COUNTRY_ANALYSIS,
  },
  {
    text: `${LABELS.calendarEvents} Report`,
    value: NOTIFICATION_BRIEFING_TYPE_CALENDAR_EVENTS,
  },
  {
    text: "Monthly Regional Outlook Report",
    value: NOTIFICATION_BRIEFING_TYPE_REGIONAL_OUTLOOK,
  },
  {
    text: "Cyber Weekly Report",
    value: NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY,
  },
  {
    text: "Cyber Monthly Report",
    value: NOTIFICATION_BRIEFING_TYPE_CYBER_MONTHLY,
  },
];

export const NOTIFICATION_TYPE_SAVED_SEARCH = "saved-search";
let docTypes = [
  { text: "Saved Search", value: NOTIFICATION_TYPE_SAVED_SEARCH },
];

export const NOTIFICATION_ASSET_TYPE_RISK_RATING = "asset-risk-rating";
export const NOTIFICATION_ASSET_TYPE_VERIFIED_EVENT = "asset-verified-event";
export const NOTIFICATION_ASSET_TYPE_BREAKING_EVENT = "asset-breaking-event";
export const NOTIFICATION_ASSET_TYPE_HOTSPOT = "asset-hotspot";
export const NOTIFICATION_ASSET_TYPE_SAVED_SEARCH = "asset-saved-search";

export const NOTIFICATION_ASSET_TYPES = [
  {
    text: "Asset Verified Events",
    value: NOTIFICATION_ASSET_TYPE_VERIFIED_EVENT,
    order: 1,
  },
  {
    text: "Asset Breaking Events",
    value: NOTIFICATION_ASSET_TYPE_BREAKING_EVENT,
    order: 1,
  },
  { text: "Asset Hotspots", value: NOTIFICATION_ASSET_TYPE_HOTSPOT, order: 2 },
  {
    text: "Asset Risk Ratings",
    value: NOTIFICATION_ASSET_TYPE_RISK_RATING,
    order: 3,
  },
  {
    text: "Asset Saved Queries",
    value: NOTIFICATION_ASSET_TYPE_SAVED_SEARCH,
    order: 4,
  },
];

docTypes = docTypes.concat(NOTIFICATION_TRIPWIRE_TYPES);
docTypes = docTypes.concat(NOTIFICATION_BRIEFING_TYPES);
docTypes = docTypes.concat(NOTIFICATION_ASSET_TYPES);
export const NOTIFICATION_DOC_TYPES = docTypes;

const daysOfWeek = DAYS_OF_WEEK.map((d) => d.name);

export const DEFAULT_NOTIFICATION = {
  formatted: {
    docType: NOTIFICATION_TRIPWIRE_TYPE_RISK_RATING,
    frequency: NOTIFICATION_FREQUENCY_IMMEDIATELY, // immediately, hourly, weekly, or daily
    dayOfWeek: daysOfWeek[dayjs().day()], // if weekly: monday, tuesday, wednesday, thursday, friday, saturday, sunday
    timeOfDay: `${dayjs().format("HH:mm")}`, // if weekly or daily: has to be on the hour or half hour only, use 24hr clock
    expiration: 1, // never, 1 week, 2 weeks, 3 weeks (set the date in the future)
    expirationDate: dayjs().add(2, "week").toISOString(),
    delivery: ["email"], // email, push
    sharedList: [], // array of objects containing userid and email
    params: {},
  },
};

export const NOTIFICATION_PULSE_TRIGGER_DROP_MIN = 1;
export const NOTIFICATION_PULSE_TRIGGER_DROP_MAX = 50;

export const NOTIFICATION_ASSET_RADIUS_MIN = 1;
export const NOTIFICATION_ASSET_RADIUS_MAX = 161;
export const NOTIFICATION_ASSET_RADIUS_DEFAULT = 10;
export const NOTIFICATION_ASSET_RADIUS_UNITS_DEFAULT = "km";

export const NOTIFICATION_GLOBAL_SEARCHES_OWNER = "Seerist";
